export function RemoveUnderscoreInstring(inputString) {
    // Check if the input is valid
    if (!inputString && typeof inputString !== 'string') {
        return '';
    }

    // Split the string into words based on underscores
    const words = inputString?.split('_');

    // Capitalize the first letter of each word and join them with spaces
    const formattedString = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

    return formattedString;
}
